import mainImage from './main-image-house.png';

export {
    mainImage
}